/*
 * Color group — переключение между товарами-братьями без перезагрузки.
 * Каждый цвет это отдельный товар; связи берутся из метаобъекта
 * custom.color_group (см. snippets/color-group-swatches.liquid).
 *
 * Клик по свотчу тянет страницу товара-брата и подменяет секции внутри
 * #MainContent, меняя URL через history.pushState. Любая ошибка — обычный
 * переход по ссылке, так что без JS и при сбое сети поведение не ломается.
 */
(function () {
  if (window.__colorGroupInit) return;
  window.__colorGroupInit = true;

  // Стили секций подключены через stylesheet_tag внутри самих секций, то есть
  // в <body>. При подмене секции они бы удалились вместе с ней и контент
  // мелькнул бы нестилизованным. Переносим их в <head> — там они переживут своп.
  function hoistSectionStyles(wrapperId) {
    var wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;
    wrapper.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      document.head.appendChild(link);
    });
  }

  function documentHasStylesheet(href) {
    if (!href) return true;
    var links = document.querySelectorAll('head link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].href === href) return true;
    }
    return false;
  }

  // innerHTML/importNode не исполняют вставленные <script>. Для второстепенных
  // секций переисполняем инлайн-скрипты вручную, обернув в IIFE.
  // ВАЖНО: для main-product этого делать нельзя — там инлайновый парольный
  // редирект объявляет `const password` в глобальном скоупе, повторное
  // исполнение бросило бы SyntaxError.
  function reexecuteInlineScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      if (old.src) return;
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript') return; // JSON и ld+json не трогаем
      var fresh = document.createElement('script');
      fresh.textContent = '(function () {\n' + old.textContent + '\n})();';
      old.replaceWith(fresh);
    });
  }

  // Модалки (size guide, галерея) переносят себя в <body> в connectedCallback,
  // поэтому после каждого свопа накапливаются дубли. Оставляем последнюю на
  // id/тег — она принадлежит текущему товару. Часть id несёт id секции шаблона,
  // а шаблоны у братьев могут различаться, поэтому нормализуем.
  function dedupeHoistedModals() {
    var groups = {};
    document.querySelectorAll('body > modal-dialog, body > product-modal').forEach(function (el) {
      var key = (el.id || el.tagName).replace(/template--\d+__/, 'template__');
      (groups[key] = groups[key] || []).push(el);
    });
    Object.keys(groups).forEach(function (key) {
      var list = groups[key];
      for (var i = 0; i < list.length - 1; i++) list[i].remove();
    });
  }

  async function swap(url, wrapperId, push) {
    // Класс загрузки вешаем на контейнер, а не на саму секцию: секция будет
    // заменена новым узлом, и снимать класс в finally стало бы не с чего.
    var container = document.getElementById('MainContent');
    if (!container || !document.getElementById(wrapperId)) {
      window.location.href = url;
      return;
    }
    container.classList.add('color-group-loading');
    try {
      // Тянем страницу целиком: кроме main-product от товара зависят и
      // остальные секции шаблона (рекомендации, описание), иначе они показывали
      // бы контент прежнего цвета.
      var res = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      // У братьев могут быть разные шаблоны (product.*.json на цвет), тогда
      // различаются и id секций (template--A__main против template--B__main).
      // Сопоставляем по суффиксу после последнего «__».
      var sectionKey = function (id) {
        return (id || '').split('__').pop();
      };
      // Нормализуем id шаблона при сравнении, иначе одинаковые по содержанию
      // секции разных шаблонов свапались бы напрасно.
      var normalize = function (html) {
        return html.replace(/template--\d+__/g, 'template__');
      };
      var isSection = function (el) {
        return el.classList && el.classList.contains('shopify-section');
      };
      // Дублирующие <link> выкидываем, реально новые отправляем в <head>, где
      // они переживут подмену секции.
      var adoptStyles = function (fresh) {
        fresh.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
          if (documentHasStylesheet(link.href)) {
            link.remove();
          } else {
            document.head.appendChild(link);
          }
        });
      };

      var freshContainer = doc.getElementById('MainContent');
      if (!freshContainer) throw new Error('#MainContent not found in response');

      var freshSections = Array.prototype.filter.call(freshContainer.children, isSection);
      if (!freshSections.length) throw new Error('no sections in response');

      var currentByKey = {};
      Array.prototype.forEach.call(container.children, function (el) {
        if (isSection(el)) currentByKey[sectionKey(el.id)] = el;
      });

      // Приводим набор секций к тому, что отдал сервер для НОВОГО товара:
      // отсутствующие вставляем, лишние удаляем, порядок восстанавливаем.
      // Полукопировать нельзя: у братьев бывают разные шаблоны (product.*.json),
      // и объединение наборов оставило бы на странице секцию прежнего товара с
      // его данными — состояние, которого при обычном переходе не бывает.
      var mainKey = sectionKey(wrapperId);
      var used = {};
      var anchor = null;

      freshSections.forEach(function (fresh) {
        var key = sectionKey(fresh.id);
        var current = currentByKey[key];
        var node;

        if (current) {
          used[key] = true;
          if (normalize(current.innerHTML) === normalize(fresh.innerHTML)) {
            // Содержимое совпало — оставляем узел как есть: живые слушатели
            // сохраняются, лишних реинициализаций нет.
            node = current;
          } else {
            hoistSectionStyles(current.id);
            adoptStyles(fresh);
            node = document.importNode(fresh, true);
            // Меняем обёртку целиком, а не innerHTML: новая секция несёт свой id
            // шаблона, и разметка внутри (data-section, формы) на него ссылается —
            // иначе следующий клик по цвету не нашёл бы свою секцию.
            current.replaceWith(node);
            // Инлайн-скрипты main переисполнять нельзя: там парольный редирект
            // объявляет `const password` в глобальном скоупе → SyntaxError.
            if (key !== mainKey) reexecuteInlineScripts(node);
          }
        } else {
          adoptStyles(fresh);
          node = document.importNode(fresh, true);
          if (anchor) {
            anchor.after(node);
          } else {
            container.insertBefore(node, container.firstChild);
          }
          reexecuteInlineScripts(node);
        }

        // Восстанавливаем порядок: узел должен идти сразу за предыдущим.
        if (anchor && node.previousElementSibling !== anchor) anchor.after(node);
        anchor = node;
      });

      Object.keys(currentByKey).forEach(function (key) {
        if (!used[key]) currentByKey[key].remove();
      });

      dedupeHoistedModals();

      if (doc.title) document.title = doc.title;
      if (push) history.pushState({ colorGroup: true }, '', url);

      document.dispatchEvent(new CustomEvent('color-group:loaded', { detail: { url: url } }));
    } catch (e) {
      window.location.href = url; // безопасный полный переход
      return;
    } finally {
      container.classList.remove('color-group-loading');
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.color-group a[data-product-url]');
    if (!link) return;

    var container = link.closest('[data-color-group]');
    var wrapperId = container && container.dataset.sectionId;
    if (!wrapperId) return; // без id секции пусть отработает обычная ссылка

    e.preventDefault();
    if (link.classList.contains('is-selected')) return;

    swap(link.dataset.productUrl, wrapperId, true);
  });

  window.addEventListener('popstate', function () {
    var cg = document.querySelector('.color-group[data-section-id]');
    if (!cg) return;
    swap(window.location.pathname + window.location.search, cg.dataset.sectionId, false);
  });

  function init() {
    var cg = document.querySelector('.color-group[data-section-id]');
    if (cg) hoistSectionStyles(cg.dataset.sectionId);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
